import { MetaItem } from './Overview'
import { Icon } from '@waylay/react-components'

interface ITag {
  label: string
  onClick?: (e?: object) => void
}

const Tag = ({ label, onClick = () => {} }: ITag) => (
  <MetaItem {...{ label, onClick }}>
    <Icon name="local_offer" />
    {label}
  </MetaItem>
)

export default Tag
